import React, { useEffect, useState } from 'react';
import clsx from "clsx";
import isEmpty from 'lodash/isEmpty';
import appColors from '../../const/colors';
import { Input, Row } from 'antd';
import { FormItem } from 'formik-antd';
import { useIntl } from 'react-intl';
import { EMPTY_VALUE_PLACEHOLDER } from '../../const/system';
import styles from './ColorPicker.module.css';


export const isValidHex = (value) => {
  return /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(value);
};

const ColorPicker = ({
  name = '',
  fieldName = '',
  defaultValue = appColors.white,
  onChange = () => {},
  disabled = false,
  error = null,
  isView = false,
  setFieldError = (_field, _msg) => {},
 }) => {
  const intl = useIntl();
  const [ color, setColor ] = useState(defaultValue);
  const [ inputValue, setInputValue ] = useState(defaultValue);
  const [ errorMessage, setErrorMessage ] = useState(error);

  useEffect(() => {
    if (defaultValue !== undefined) {
      const newValue = !isEmpty(defaultValue) ? defaultValue : null;
      setColor(newValue);
      setInputValue(newValue);
    }
  }, [ defaultValue ]);

  const handleColorChange = (event) => {
    let newColor = event.target.value.toUpperCase();

    // color always should get the default value even if it's not set
    if (isEmpty(newColor)) {
      newColor = defaultValue;
    }

    setColor(newColor);
    setInputValue(newColor);
    setErrorMessage(null);
    onChange(newColor);
  };

  // validate hex value on blur
  const handleBlur = (event) => {
    let newColor = event.target.value.toUpperCase();

    if (!isValidHex(newColor)) {
      setFieldError(`data.${fieldName}.value`, intl.formatMessage({ id: 'ui-general-invalid-hex' }));
      setErrorMessage(intl.formatMessage({ id: 'ui-general-invalid-hex' }));
    }
  }

  return (
      <Row className={clsx({[styles.centered]: isView})}>
        <Input
          name={name}
          disabled={disabled}
          type="color"
          className={styles.input}
          id={name}
          value={color}
          onChange={handleColorChange}
        />
        <label
          htmlFor={name}
          className={clsx(styles.display, {[styles.labelActive]: !disabled})}
          style={{ backgroundColor: color, width: "32px" }}
        />

        {isView ? (
          <span className={styles.text}>
            {!isEmpty(color) ? color.toUpperCase() : EMPTY_VALUE_PLACEHOLDER}
          </span>
        ) : (
          <FormItem
            name='input-hex-value'
            validateStatus={errorMessage ? "error" : ""}
            help={errorMessage}
            className='hp-ml-8 hp-mb-0'
          >
            <Input
              size='small'
              placeholder="HEX value"
              style={{ width: 100, minHeight: "unset" }}
              name={name}
              value={inputValue || null}
              onChange={handleColorChange}
              onBlur={handleBlur}
              disabled={disabled}
            />
          </FormItem>
        )}
      </Row>
  );
};


export default ColorPicker;
